import React from 'react';

const AdminSocial = () => {
    return (
        <div className="section-padding">
            <div className="container-custom">
                <h1 className="text-3xl font-bold mb-6">Manage Social Posts</h1>
                <p className="text-gray-600">Social media management interface coming soon.</p>
            </div>
        </div>
    );
};

export default AdminSocial;
